<template>
    <div class="custom-control custom-switch">
        <input :value="value"
               :checked="value ? 'checked' : false"
               :disabled="disabled ? 'disabled' : false"
               @change="$emit('toggle', !value)"
               type="checkbox"
               class="custom-control-input"
               :tabindex="tabindex"
               :id="`app-switch-${id}`"/>
        <label class="custom-control-label" :for="`app-switch-${id}`">
            <slot name="label">
                {{ value ? 'Enabled' : 'Disabled' }}
            </slot>
        </label>
    </div>
</template>

<script>
import {getRandomId} from '@/utils'

export default {
    name: 'AppSwitch',
    props: {
        id: {
            type: String,
            required: false,
            default: () => getRandomId()
        },
        value: {
            type: [Boolean, Number],
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tabindex: {
            type: Number,
            default: 0
        }
    },
    model: {
        prop: 'value',
        event: 'toggle'
    }
}
</script>

<style lang="scss" scoped>
.custom-control {
    font-size: 14px;
    line-height: 24px;
}
</style>
